import { PageDescription } from '@reflex/ui/components/layout/Typography';
import { DataTable, type DataTableColumn } from '@/components/shared/DataTable';
import { formatDateTimeWithSeconds } from '@reflex/ui/lib/format';
import { StatusCodeBadge } from './WebhookStatusBadge';
import type { WebhookEventRecord } from '@/lib/types';

const eventColumns: DataTableColumn<WebhookEventRecord>[] = [
  {
    header: 'Time',
    cell: (event) => formatDateTimeWithSeconds(event.receivedAt),
    cellClassName: 'text-muted-foreground whitespace-nowrap',
  },
  {
    header: 'Path',
    cell: (event) => (
      <span className="font-mono text-2xs max-w-[200px] truncate block" title={event.path}>
        {event.path}
      </span>
    ),
  },
  {
    header: 'Status',
    cell: (event) => <StatusCodeBadge code={event.statusCode} />,
  },
  {
    header: 'Duration',
    headerClassName: 'text-right',
    cellClassName: 'text-right text-muted-foreground tabular-nums',
    cell: (event) => `${event.durationMs}ms`,
  },
  {
    header: 'Error',
    cell: (event) => (
      <span className="text-status-error max-w-[200px] truncate block" title={event.error}>
        {event.error ?? '—'}
      </span>
    ),
  },
];

export function RecentEventsTable({ events }: { events: WebhookEventRecord[] }) {
  if (events.length === 0) {
    return (
      <PageDescription className="text-xs py-3 text-center">
        No recent events recorded
      </PageDescription>
    );
  }

  const sorted = [...events].reverse();

  return (
    <DataTable<WebhookEventRecord>
      data={sorted}
      columns={eventColumns}
      rowKey={(event) => `${event.receivedAt}-${event.path}`}
    />
  );
}
